import styled from 'styled-components';
import {AlertInfo} from '../AlertInfo';

const StyledLink = styled('p')`
	font-weight: 700;
	text-decoration: underline;
	color: ${({theme}) => theme.colors.light.primary.main};
`;

const StyledAlertSuspended = styled(AlertInfo.Root)`
	margin: 8px 0 -8px;
	padding: 0 0 0 8px;
	position: relative;
	z-index: 4;
	cursor: pointer;
`;

export {StyledLink, StyledAlertSuspended};
